import React, { useMemo } from "react";
import clsx from "clsx";
import {
  EmailBuilderState,
  EmailFooterProfile,
  renderEmailBuilderState,
} from "./emailBuilderData";

export type EmailFooterPreviewProps = {
  builderState: EmailBuilderState;
  footerProfile?: EmailFooterProfile | null;
  title: string;
  className?: string;
};

const EmailFooterPreview = ({
  builderState,
  footerProfile,
  title,
  className,
}: EmailFooterPreviewProps) => {
  // Render the persisted email HTML itself instead of maintaining another
  // React approximation. This keeps Steps 2 and 3 visually identical to the
  // footer that is reviewed, test-sent, and ultimately delivered.
  const footerDocument = useMemo(() => {
    const { footerHtml } = renderEmailBuilderState(
      builderState,
      footerProfile || undefined
    );

    return [
      "<!doctype html>",
      '<html><head><meta name="viewport" content="width=device-width,initial-scale=1" /></head>',
      '<body style="margin:0;background:#f8fafc;">',
      footerHtml,
      "</body></html>",
    ].join("");
  }, [builderState, footerProfile]);

  return (
    <iframe
      srcDoc={footerDocument}
      title={title}
      scrolling="no"
      sandbox=""
      className={clsx(
        "pointer-events-none h-[320px] w-full border-0 bg-slate-50",
        className
      )}
    />
  );
};

export default EmailFooterPreview;
